import React, { FC } from "react";
import { IOpsProps } from "../IOpsProps";
import NotYetImpl from "../not-yet-impl/NotYetImpl";
import Operation from "../Operation";
import UpgradeTeacher from "./UpgradeTeacher";

export type UserOps = 'set_password' | 'update_email' | 'upgrade_to_pro_teacher' | 'update_emails_with_csv' | 'list_contracts'

export const userOpsMap: Record<UserOps, any> = {
  set_password: NotYetImpl,
  update_email: NotYetImpl,
  upgrade_to_pro_teacher: UpgradeTeacher,
  update_emails_with_csv: NotYetImpl,
  list_contracts: NotYetImpl,
};

export interface UserOpsProps extends IOpsProps {
  ops: UserOps[];
};

const UserOps: FC<UserOpsProps> = (props) => {

  const operations = props.ops.map((value: UserOps) => {
    return (
      <Operation name={value} key={value}>
        { userOpsMap[value](props) }
      </Operation>
    );
  });

  return (
    <>
    {operations}
    </>
  );
}

export default UserOps;
